<ng-container *ngIf="!config?.isList">
    <span *ngIf="config?.labelLocal">
        {{ config?.value?.[config?.displayProperty] }}-{{ config?.value?.mapLocalLibelle?.[config.labelLocal] }}
    </span>
    <span *ngIf="!config?.labelLocal"> {{ config?.value?.[config?.displayProperty] }}</span>
   
</ng-container>
<ng-container *ngIf="config?.isList">
    <div *ngFor="let obj of config.value">
        <span *ngIf="obj?.labelLocal">
            {{ obj?.[config?.displayProperty] }}-{{ obj?.mapLocalLibelle?.[config.labelLocal] }}
        </span>
        <span *ngIf="!obj?.labelLocal"> {{ obj?.[config?.displayProperty] }}</span>
    </div>
   
</ng-container>
